import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  BasicInformationStyles: {
    padding: "12px 0",
    fontFamily: "'Inter', sans-serif",
    display: "flex",
    gap: "32px",
  },
  leftColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "220px",
  },
  avatarWrapper: {
    position: "relative",
    width: "200px",
    height: "150px",
    marginBottom: "12px",
    borderRadius: "8px",
    overflow: "hidden",
    border: "2px solid #e5e7eb",
    backgroundColor: "#f8fafc",
  },
  avatarImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  editIconOverlay: {
    position: "absolute",
    bottom: "8px",
    right: "8px",
    backgroundColor: "#1a1a1a",
    color: "#fff",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: "#333",
    },
    "& svg": {
      fontSize: "15px",
    },
  },
  photoLabel: {
    fontSize: "13px !important",
    fontWeight: "600 !important",
    color: "#1a1a1a",
    fontFamily: "'Inter', sans-serif !important",
  },
  photoSubLabel: {
    fontSize: "11px !important",
    color: "#94a3b8",
    fontFamily: "'Inter', sans-serif !important",
    textAlign: "center",
  },
  rightColumn: {
    flex: 1,
  },
  formLabel: {
    display: "block",
    fontSize: "13px",
    fontWeight: "500",
    color: "#374151",
    marginBottom: "6px",
    fontFamily: "'Inter', sans-serif",
  },
  formInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      fontFamily: "'Inter', sans-serif",
      fontSize: "14px",
      backgroundColor: "#fff",
      "& fieldset": {
        borderColor: "#e5e7eb",
      },
      "&:hover fieldset": {
        borderColor: "#9ca3af",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#6b7280",
        borderWidth: "1px",
      },
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#9ca3af",
      opacity: 1,
    },
  },
  autocompleteInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      fontFamily: "'Inter', sans-serif",
      fontSize: "14px",
      backgroundColor: "#fff",
      padding: "2px 8px !important",
      "& fieldset": {
        borderColor: "#e5e7eb",
      },
      "&:hover fieldset": {
        borderColor: "#9ca3af",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#6b7280",
        borderWidth: "1px",
      },
    },
  },
}));

export default useStyles;
